import React, { useEffect, useState } from 'react';
import { Modal, } from 'antd';
import axios from '../Common/axios';
import InfoTable from './InfoTable';
import { suggestColumnData } from './columns';
import { getFindInfoSuggestListData, postSaveVaSuggestData } from '../Common/api';

import { suggestListData } from '../Common/tempData';

function InfoSuggest({ reportId }) {

    const [dataSource, setDataSource] = useState(suggestListData);
    //const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const titleName="권고사항 등록";

    useEffect(() => {
        //자동조회
        if (reportId) {
            findInfoSuggestListData();
        }
    }, []);

    const findInfoSuggestListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({ title:titleName, content:"Report ID가 누락 되었습니다." });
            return;
        }

        setIsLoading(true);
        axios.get(getFindInfoSuggestListData(reportId))
            .then((response) => {
                setIsLoading(false);
                // const resDataLine = response.data.map(item => {
                //     (item.suggest_desc != "" && item.suggest_desc != "N/A") ? item.suggest_desc.replaceAll(/\\n/, '\n'):"";
                // });
                const resDataLine = response.data.map(item => {
                    return {
                        ...item,
                        suggest_desc: item.suggest_desc.replaceAll(/(\\n|\n)/g, "<br />")
                    };
                });
                setDataSource(resDataLine);
                //if(response.data.totalCount == 0) {
                //    Modal.info({title: "조회된 결과가 없습니다.", okText:"닫기"});
                //} 
            }).catch((error) => {
                setIsLoading(false);
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if (saveData.length > 0) {
            saveCheckList(saveData);
        } else {
            Modal.info({ title:titleName, content:"변경된 데이타가 없습니다.", okText: "Close" });
        }

    }

    // 등록/수정/삭제 API
    const saveCheckList = (saveData) => {

        axios.post(postSaveVaSuggestData()
            , { reportId: reportId, saveData: saveData }
            , { logType: '/edit/TemplateSuggest/', logParam: reportId })
            .then((response) => {
                //console.log(response);
                //Modal.info({title: "OK.", okText:"Close"});
                if (response.data == '000') {
                    Modal.info({ title:titleName, content:"정상적으로 등록되었습니다.", okText: "Close" });
                } else {
                    Modal.info({ title:titleName, content:response.data, okText: "Close" });
                }

                //재조회
                findInfoSuggestListData();
            })
            .catch((error) => {
                Modal.error({ title:titleName, content:error.message, okText: "Close" });
            });
    };

    // 정보 변경시 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoSuggestListData();
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <div className='tab_content'>
                <InfoTable
                    data={dataSource}
                    columnData={suggestColumnData}
                    rowkey="id"
                    reportId={reportId}
                    infoType={'suggest'}
                    isLoading={isLoading}
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    fullHeight={!!window.opener} />
            </div>
        </>
    );
}

export default InfoSuggest;